// extracted by mini-css-extract-plugin
export default {"CP_home":"style_CP_home__Xrknb"};